module.exports = __webpack_public_path__ + "img/workout-notebook_B095Q3YTTT.46c75204.jpg";